export function isRunningInConnectDesktop(env = process.env): boolean {
    return env._GD_STARTING_CONTEXT_ !== undefined;
}

export type ApplicationConfig = {
    name: string;
    customProperties?: {
        gatewayApp?: boolean
        [key: string]: unknown
    }
    [key: string]: unknown
}

export type StartingContext = {
    instanceId: string
    env: string
    region: string
    applicationConfig?: ApplicationConfig
    [key: string]: unknown
}

export function parseStartingContext(env = process.env): StartingContext {
    if (!isRunningInConnectDesktop(env)) {
        throw new Error("Not running in io.Connect Desktop");
    }
    return JSON.parse(env._GD_STARTING_CONTEXT_);
}
